import { Component, inject, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth-service';
import { NotificationService } from '../../../services/notification-service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-login',
  imports: [
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
  MatButtonModule,
  MatIconModule,
  ],
  templateUrl: './login.html',
  styleUrl: './login.scss',
})
export class Login {
  private fb = inject(FormBuilder);
  private router = inject(Router);
  private authService = inject(AuthService);
  private notificationService = inject(NotificationService);
  submitting = signal(false);

  form = this.fb.nonNullable.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required, Validators.minLength(6)]],
  });

  get email() { return this.form.get('email'); }
  get password() { return this.form.get('password'); }

  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.submitting.set(true);

    this.authService.login(this.email?.value!, this.password?.value!).subscribe({
      next: (res) => {
        this.submitting.set(false);
        this.authService.setAccessToken(res.accessToken);
        if ((res as any).userData) {
          this.authService.setUserData((res as any).userData);
          this.router.navigate(['/vessels']);
        } else {
          this.authService.fetchCurrentUser().subscribe({
            next: () => this.router.navigate(['/vessels']),
            error: () => this.router.navigate(['/vessels'])
          });
        }
      },
      error: (err) => {
        this.submitting.set(false);
        this.notificationService.openSnackbar('snackbar.error_auth','error','right','top',10000);
      }
    });
  }

  gotoForgotPassword() {
    this.router.navigate(['/forgotPassword']);
  }
}
